import { ServiceCategory } from "../../model/client_service/serviceCategory";
import { AbstractRestService } from "../abstractRestService";

export class ServiceCategoryService extends AbstractRestService<ServiceCategory> {
    constructor() {
      super('/api/service-category');
    }  
}
export const serviceCategoryService = new ServiceCategoryService();